<template>
  <div class="mt-3">
    <div class="steps d-flex justify-center">
      <CartStep class="step" :step="1" :current-step="step" to="/shop/cart">カート</CartStep>
      <CartStep class="step" :step="2" :current-step="step">
        <span class="hidden-sm-and-down">購入</span>確認
      </CartStep>
    </div>
    <PageContainer class="cart-layout">
      <div class="cart-title">{{ title }}</div>
      <div v-if="$slots.before" class="content-before">
        <slot name="before" />
      </div>
      <CartSectionTitle v-if="subTitle" class="sub-title">{{ subTitle }}</CartSectionTitle>
      <div class="content mb-8">
        <slot />
      </div>
      <div class="price">
        <CartPriceCard :order="order" :button-text="nextText" :button-to="nextTo" @button-click="$emit('next')" />
        <div class="prev">
          <Button  size="big" block color="inherit-border-green" :to="prevTo">{{ prevText }}</Button>
        </div>
      </div>
    </PageContainer>
  </div>
</template>

<script>
import PageContainer from "@/components/shop/PageContainer.vue";
import CartStep from "@/components/shop/cart/CartStep.vue";
import CartSectionTitle from "@/components/shop/cart/CartSectionTitle.vue";
import CartPriceCard from "@/components/shop/cart/CartPriceCard.vue";
import Button from "@/components/shop/Button.vue";

export default {
  components: {
    PageContainer,
    CartStep,
    CartSectionTitle,
    CartPriceCard,
    Button
  },

  props: {
    title: {
      type: String,
      default: ""
    },
    subTitle: {
      type: String,
      default: ""
    },
    nextText: {
      type: String,
      default: ""
    },
    nextTo: {
      type: String,
      default: ""
    },
    prevText: {
      type: String,
      default: ""
    },
    prevTo: {
      type: String,
      default: ""
    },
    step: {
      type: Number,
      default: 0
    },
    order: {
      type: Object,
      default: null
    }
  }
};
</script>

<style lang="scss" scoped>
.cart-layout {
  display: grid;
  grid-template-columns: 1fr 268px;
  grid-gap: 0 8px;

  @media screen and (max-width: 960px) {
    display: block;
  }
}

.steps {
  grid-column: span 2;
}

.step {
  margin: 0 8px;

  @media screen and (max-width: 960px) {
    margin: 0 4px;
  }
}

.cart-title {
  grid-column: span 2;
  margin: 40px 0 18px;
  color: #333;
  font-size: 32px;
  font-weight: bold;
  text-align: center;
}

.content-before {
  grid-column: span 2;
  margin: 24px 0;
}

.sub-title {
  grid-column: span 2;
  margin-top: 0;
}

.prev {
  padding: 16px;
}
</style>
